// extracted by mini-css-extract-plugin
export default {"wrapper":"GameImage_wrapper__soHi5","mosaicWrapper":"GameImage_mosaicWrapper__5ZaSA"};